export type Lead = {
    firstName: string;
    lastName: string;
    address1: string;
    address2: string;
    postalCode: string;
    city: string;
    state: string;
    country: string;
    emailAddress: string;
    phoneNumber: string;
    shipFirstName: string;
    shipLastName: string;
    shipAddress1: string;
    shipAddress2: string;
    shipPostalCode: string;
    shipCity: string;
    shipState: string;
    shipCountry: string;
    campaignId: string;
}

export type Order = {
    firstName: string;
    lastName: string;
    address1: string;
    address2: string;
    postalCode: string;
    city: string;
    state: string;
    country: string;
    emailAddress: string;
    phoneNumber: string;
    paySource: string;
    cardNumber: string;
    cardMonth: string;
    cardYear: string;
    cardSecurityCode: string;
    campaignId: string;
    product1_id: string;
    product1_qty: string;
    altFirstName?: string;
    altLastName?: string;
    altAddress1?: string;
    altAddress2?: string;
    altPostalCode?: string;
    altCity?: string;
    altState?: string;
    altCountry?: string;
}

export enum PageType {
    leadPage = 'leadPage',
    checkoutPage = 'checkoutPage',
    upsell = 'upsell',
    thankYouPage = 'thankYouPage',
}

export type Click = {
    pageType: PageType;
    sessionId?: string;
    campaignId?: string;
    requestUri?: string;
}